import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PrimeNGTranslationService } from './primeng-translation.service';
import { Language } from '../enums';
import { translateRawPaths } from '../route-translation/helpers/translate-raw-paths';

@Injectable({ providedIn: 'root' })
export class LanguageService {
	private readonly _selectedLanguage$ = new BehaviorSubject<Language>(Language.Serbian);
	public selectedLanguage$ = this._selectedLanguage$.asObservable();
	public readonly selectedLanguage = signal<Language>(Language.Serbian);

	private readonly translateService = inject(TranslateService);
	private readonly router = inject(Router);
	private readonly primeNgTranslationService = inject(PrimeNGTranslationService);
	private readonly languages: { label: 'SR'; value: Language }[] = [{ label: 'SR', value: Language.Serbian }];

	public getLanguages(): { label: string; value: string }[] {
		return this.languages;
	}

	public getSelectedLanguage(): Language {
		return this._selectedLanguage$.getValue() as Language;
	}

	public getSelectedLocale(): 'en-US' | 'sr-Latn' {
		return this.getSelectedLanguage() === Language.Serbian ? 'sr-Latn' : 'en-US';
	}

	public setLanguage(language: Language, skipNavigation?: boolean): void {
		this.translateService.use(language);
		this.primeNgTranslationService.setTranslation(language);
		this._selectedLanguage$.next(language);
		this.selectedLanguage.set(language);

		if (!skipNavigation) {
			this.navigateToTranslatedUrl(language);
		}
	}

	public isSupportedLanguage(language: string): boolean {
		return (Object.values(Language) as string[]).includes(language);
	}

	private navigateToTranslatedUrl(language: Language): void {
		const urlSegments = this.router.url.split('/');
		urlSegments[1] = language;

		const paths = translateRawPaths(urlSegments, language);

		this.router.navigateByUrl(paths.join('/'), { replaceUrl: true });
	}
}
